// src/components/auth/TalentRoute.jsx
// Allows: talent role (and admin)
// Blocks:  collaborators → shows access-denied screen
// Guests:  redirects to home
import { Navigate, Outlet } from 'react-router-dom';
import { useNavigate }      from 'react-router-dom';
import { useAuth }          from '../../hooks/useAuth';
import { PageLoader }       from '../ui/Spinner';
import { C }                from '../../styles/tokens';

function CollaboratorBlocked() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 24px 24px' }}>
      <div style={{ maxWidth: 460, textAlign: 'center' }}>
        {/* Icon */}
        <div style={{ width: 80, height: 80, borderRadius: 20, background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36, margin: '0 auto 24px' }}>
          🔒
        </div>

        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 14px', borderRadius: 100, background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.25)', color: C.warning, fontSize: 11, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 18 }}>
          Access Restricted
        </span>

        <h1 className="syne" style={{ fontSize: 'clamp(1.6rem,4vw,2.2rem)', fontWeight: 800, marginBottom: 14, letterSpacing: '-0.02em' }}>
          Training is for <span style={{ color: C.magenta }}>Talent</span> Only
        </h1>

        <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.5)', lineHeight: 1.7, marginBottom: 32 }}>
          The Training Hub is designed for talent members looking to upskill and earn certificates. As a company partner, your workspace is the Collaborator Portal.
        </p>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/collaborators')}
            style={{ padding: '13px 28px', background: `linear-gradient(135deg,${C.magenta},${C.violet})`, border: 'none', borderRadius: 10, color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: "'Syne',sans-serif" }}
          >
            Go to My Portal →
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            style={{ padding: '12px 24px', background: 'transparent', border: '1px solid rgba(254,52,232,0.3)', borderRadius: 10, color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
          >
            Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default function TalentRoute() {
  const { user, profile, loading } = useAuth();

  if (loading) return <PageLoader />;

  // Not logged in → back to home
  if (!user) return <Navigate to="/" replace />;

  // Collaborator → blocked screen
  if (profile?.role === 'collaborator') return <CollaboratorBlocked />;

  // Talent or admin → allow
  return <Outlet />;
}
